// Flag to prevent unauthorized handler during initial auth check
let isInitializing = true;

export const isAuthInitializing = () => isInitializing;

export const markInitComplete = () => {
  isInitializing = false;
};
